import { render, staticRenderFns } from "./emoji.vue?vue&type=template&id=f3164cb6&scoped=true"
import script from "./emoji.vue?vue&type=script&lang=js"
export * from "./emoji.vue?vue&type=script&lang=js"
import style0 from "./emoji.vue?vue&type=style&index=0&id=f3164cb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3164cb6",
  null
  
)

export default component.exports